export default "__VITE_ASSET__D_s12$t3__"